console.log('Amaya fullscreen zoom loaded');

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 750) return;

  /* =============================
     ELEMENTS
  ============================== */
  const overlay = document.getElementById('amaya-zoom');
  const zoomImg = document.getElementById('amaya-zoom-image');
  const closeBtn = document.getElementById('amaya-zoom-close');
  const thumbsBox = document.getElementById('amaya-zoom-thumbs');
  const backdrop = document.getElementById('amaya-zoom-backdrop');

  if (!overlay || !zoomImg || !closeBtn || !thumbsBox || !backdrop) {
    console.warn('Amaya Zoom: required elements missing');
    return;
  }

  /* =============================
     STATE
  ============================== */
  let images = [];
  let currentIndex = 0;
  const boundSliders = new WeakSet();

  /* =============================
     OPEN / CLOSE
  ============================== */
  function openZoom(index = 0) {
    if (!images.length || !images[index]) return;

    currentIndex = index;

    overlay.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('amaya-zoom-open');

    requestAnimationFrame(() => {
      zoomImg.style.setProperty(
        'background-image',
        `url("${images[currentIndex]}")`,
        'important'
      );
      zoomImg.style.setProperty('background-position', '50% 50%', 'important');
    });

    renderThumbs();
  }

  function closeZoom() {
    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('amaya-zoom-open');

    zoomImg.style.removeProperty('background-image');
  }

  /* =============================
     IMAGE COLLECTION
  ============================== */
  function getImageSlides(slider) {
    return Array.from(
      slider.querySelectorAll('.product__media-item[data-media-id]')
    ).filter((slide) => slide.querySelector('.product__modal-opener--image img'));
  }

  function collectImages(slider) {
    images = getImageSlides(slider)
      .map((slide) => {
        const img = slide.querySelector('.product__modal-opener--image img');
        return (
          img?.dataset.originalSrc ||
          img?.currentSrc ||
          img?.src ||
          img?.getAttribute('data-src')
        );
      })
      .filter(Boolean);

    console.log('Amaya Zoom images:', images);
  }

  function showImage(index) {
    if (!images[index]) return;

    currentIndex = index;

    zoomImg.style.setProperty(
      'background-image',
      `url("${images[currentIndex]}")`,
      'important'
    );
    zoomImg.style.setProperty('background-position', '50% 50%', 'important');

    renderThumbs();
  }

  /* =============================
     THUMBNAILS
  ============================== */
  function renderThumbs() {
    thumbsBox.innerHTML = '';

    images.forEach((src, i) => {
      const thumb = document.createElement('img');
      thumb.src = src;

      if (i === currentIndex) thumb.classList.add('active');

      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showImage(i);
      });

      thumbsBox.appendChild(thumb);
    });
  }

  /* =============================
     SLIDER BINDING
  ============================== */
  function bindSlider(slider) {
    if (!slider || boundSliders.has(slider)) return false;

    collectImages(slider);
    if (!images.length) return false;

    slider.addEventListener(
      'click',
      (e) => {
        const slide = e.target.closest('.product__media-item[data-media-id]');
        if (!slide || !slider.contains(slide)) return;
        if (!slide.querySelector('.product__modal-opener--image img')) return;

        e.preventDefault();
        e.stopPropagation();

        collectImages(slider);

        const slides = getImageSlides(slider);
        const index = slides.indexOf(slide);
        if (index === -1) return;

        openZoom(index);
      },
      true
    );

    boundSliders.add(slider);
    console.log('Amaya Zoom: slider bound');
    return true;
  }

  function bindSliders() {
    let foundSlider = false;

    document
      .querySelectorAll('media-gallery slider-component[id^="GalleryViewer-"]')
      .forEach((slider) => {
        if (bindSlider(slider)) foundSlider = true;
      });

    return foundSlider;
  }

  if (!bindSliders()) {
    const observer = new MutationObserver(() => {
      if (bindSliders()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* =============================
     MOUSE MOVE PAN
  ============================== */
  zoomImg.addEventListener('mousemove', (e) => {
    if (!overlay.classList.contains('active')) return;

    const rect = zoomImg.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    zoomImg.style.setProperty(
      'background-position',
      `${Math.max(0, Math.min(100, x))}% ${Math.max(0, Math.min(100, y))}%`,
      'important'
    );
  });

  /* =============================
     CLOSE INTERACTIONS
  ============================== */
  closeBtn.addEventListener('click', closeZoom);
  backdrop.addEventListener('click', closeZoom);

  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('active')) return;

    if (e.key === 'Escape') closeZoom();

    if (images.length > 1) {
      if (e.key === 'ArrowRight') {
        showImage((currentIndex + 1) % images.length);
      }
      if (e.key === 'ArrowLeft') {
        showImage((currentIndex - 1 + images.length) % images.length);
      }
    }
  });
});